import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface TableTransferDialogProps {
  open: boolean;
  onClose: () => void;
  sourceTable: {
    id: string;
    name: string;
    displayNumber?: string;
    activeOrderCount?: number;
  };
}

/**
 * TableTransferDialog - Now a thin wrapper that immediately navigates to table layout
 *
 * When opened, it automatically navigates to the table layout page in transfer mode.
 * The actual confirmation and transfer happens in Visual2DLayoutManager.
 */
const TableTransferDialog: React.FC<TableTransferDialogProps> = ({
  open,
  onClose,
  sourceTable
}) => {
  const navigate = useNavigate();

  // Automatically navigate to table layout when dialog opens
  useEffect(() => {
    if (open && sourceTable?.id) {
      // Close the dialog
      onClose();

      // Navigate to tables page with transfer mode state
      navigate('/vendor/tables', {
        state: {
          transferMode: true,
          sourceTableId: sourceTable.id,
          sourceTableName: sourceTable.displayNumber || sourceTable.name,
          activeOrderCount: sourceTable.activeOrderCount || 0
        }
      });
    }
  }, [open, sourceTable, onClose, navigate]);

  // This component doesn't render anything visible
  // It just handles the navigation when triggered
  return null;
};

export default TableTransferDialog;
